import React, {Component} from 'react';
import _ from 'lodash';
import uuidv4 from 'uuid/v4'
import classNames from 'classnames';
import RenderHtml from "../renderFunction";
import {nullToString} from "../function";
import IMask from "imask";
import {Button, Input, Select} from 'semantic-ui-react'

export default class Base extends Component {
  constructor(props) {
    super(props);
    let {value, mask, errorMessage} = this.props;
    value = nullToString(value);

    // Mask options
    let maskOptions = {};
    if (mask && !_.isEmpty(mask)) {
      maskOptions = {
        mask: String(mask)
      };
    }

    const {dropdown, dropdownDefaultValue} = this.props;
    this.state = {
      ...this.props,
      uuid: uuidv4(),
      value: value,
      errorMessage: errorMessage ? errorMessage : '',
      maskOptions: maskOptions,
      dropdownValue: dropdown && !_.isEmpty(dropdown) && _.isArray(dropdown) && dropdownDefaultValue ? dropdownDefaultValue : ''
    }
  }

  componentDidMount() {
    const {maskOptions, uuid, validate, errorMessage, value, autoFocus} = this.state;
    const {formContext} = this.props;

    let val = nullToString(value);

    this.setState({
      manualErrorMessage: errorMessage,
      value: val
    }, () => {
      validate && formContext.validate(uuid, val, validate, errorMessage);
    });

    if (maskOptions && !_.isEmpty(maskOptions)) {
      let element = document.querySelector('input');
      // let element = ReactDOM.findDOMNode('input');
      new IMask(element, maskOptions);
    }

    if (autoFocus) {
      document.querySelector('input').focus()
    }

  }

  componentWillReceiveProps(nextProps) {
    const {value, errorMessage, formContext} = nextProps;
    const {uuid, maskOptions, validate} = this.state;

    if (value !== this.props.value) {
      let newValue = nullToString(value);

      if (maskOptions && !_.isEmpty(maskOptions) && newValue) {
        let masked = IMask.createMask(maskOptions);
        newValue = masked.resolve(newValue)
      }

      this.setState({
        value: newValue
      }, () => {
        validate && formContext.validate(uuid, newValue, validate, errorMessage);
      });
    }

    if (errorMessage !== this.props.errorMessage) {
      this.setState({
        ...nextProps,
        manualErrorMessage: errorMessage,
        value: nullToString(value)
      }, () => {
        validate && formContext.validate(uuid, nullToString(value), validate, errorMessage);
      })
    }

    if (formContext !== this.props.formContext) {
      if (formContext.click) {
        let msg = formContext.messages.filter(item => item.id === uuid);
        this.setState({
          errorMessage: msg.length ? msg[0].messages : null,
        })
      }
    }

  }

  focus = () => {
    this.input.focus()
  };

  handleChange = (e) => {
    const {onChange, formContext, dropdown} = this.props;
    const {uuid, validate, manualErrorMessage, dropdownValue} = this.state;
    let val = e.target.value;

    const inputValue = val;

    if (dropdown && !_.isEmpty(dropdown) && _.isArray(dropdown)) {
      val = {
        inputValue: val,
        dropdownValue: this.state.dropdownValue
      }
    }

    this.setState({
      value: val,
    }, () => {
      validate && formContext.validate(uuid, _.trim(inputValue), validate, manualErrorMessage);
      onChange && this.props.onChange(this.state.value)
    })
  };

  handleBlur = (e) => {
    const {onChange, formContext, dropdown} = this.props;
    const {uuid, validate, manualErrorMessage, dropdownValue} = this.state;
    let val = e.target.value;

    const inputValue = val;

    if (dropdown && !_.isEmpty(dropdown) && _.isArray(dropdown)) {
      val = {
        inputValue: val,
        dropdownValue: dropdownValue
      }
    }

    this.setState({
      value: val,
    }, () => {
      validate && formContext.validate(uuid, _.trim(inputValue), validate, manualErrorMessage);
      onChange && this.props.onChange(this.state.value)
    })
  };

  inputValue() {
    const {dropdown} = this.props;
    const {value} = this.state;

    if (dropdown && !_.isEmpty(dropdown) && _.isArray(dropdown)) {
      return value.inputValue || ''
    } else {
      return value || ''
    }
  }

  renderButton() {
    const {button} = this.props;

    if (button && !_.isEmpty(button) && _.isObject(button)) {
      return <Button
        type="button"
        basic={button.basic}
        color={button.color}
        onClick={button.onClick}
      >
        {button.text}
      </Button>
    }
  }

  renderDropDown() {
    const {dropdown, displayValue, displayField, dropdownDefaultValue} = this.props;

    if (dropdown && !_.isEmpty(dropdown) && _.isArray(dropdown)) {
      let ddItems = [];

      dropdown.forEach(item => {
        ddItems.push({
          text: item.text ? item.text : item[displayField],
          value: item.value ? item.value : item[displayValue]
        })
      });

      return <Select
        compact
        options={ddItems}
        defaultValue={dropdownDefaultValue}
        onChange={(e, data) => this.selectChange(e, data)}
      />
    }
  }

  selectChange(e, data) {

    const {onChange, dropdown, displayValue, formContext} = this.props;
    const {uuid, validate, manualErrorMessage, value} = this.state;

    this.setState({
      dropdownValue: dropdown.filter(item => item[displayValue] === data.value),
      value: {
        inputValue: this.inputValue(),
        dropdownValue: data.value
      }
    }, () => {
      validate && formContext.validate(uuid, this.inputValue(), validate, manualErrorMessage);
      onChange && this.props.onChange(this.state.value)
    })
  }

  renderInput(option) {
    const {dropdown, button} = this.state;

    if (dropdown && !_.isEmpty(dropdown) && _.isArray(dropdown) && !button) {
      return <Input {...option} action>
        <input/>
        {this.renderDropDown()}
      </Input>
    } else if (button && !_.isEmpty(button) && _.isObject(button) && !dropdown) {
      return <Input {...option} action>
        <input/>
        {this.renderButton()}
      </Input>
    }

    return <Input {...option} />
  }

  render() {

    let {readOnly, disabled, maxSize, value, errorMessage, autoFocus, title, titleLeft, md, sm, rounded, customClass, type, placeholder, label, loading, transparent, line, icon, dropdown, button, size} = this.state,
      containerClass = classNames('app-base-component-container', {
        'data-active': value && !_.isEmpty(value),
        'error-label': errorMessage && !_.isEmpty(errorMessage),
        'line': line,
        'is-title-left': titleLeft,
        'is-title-top': title && !titleLeft,
        'transparent': transparent,
        'rounded': rounded
      });

    let elementOptions = {
      id: RenderHtml.renderId(this.state),
      type: type === 'text' ? 'text' : 'password',
      placeholder: placeholder ? placeholder : '',
      name: RenderHtml.renderName(this.state),
      disabled: disabled,
      readOnly: readOnly,
      fluid: true,
      size: size,
      defaultValue: this.inputValue(),
      maxLength: maxSize,
      onChange: (val) => {
        this.handleChange(val)
      },
      onBlur: (val) => {
        this.handleBlur(val)
      },
      focus: autoFocus,
      loading: loading,
      ...RenderHtml.renderLabel(label, dropdown, button),
      ...RenderHtml.renderIcon(icon),
      tabIndex: this.state.tabIndex,
      ref: ref => this.input = ref
    }

    return (
      <div className={`${containerClass} ${customClass ? customClass : ''}`}>
        {this.renderInput(elementOptions)}
        {RenderHtml.renderCaption(this.state)}
        {RenderHtml.renderError(this.state)}
      </div>
    );


  }
}
